import BaseIcon from './icon'
import ActionIcon from './actionIcon'

const Icon = BaseIcon
Icon.ActionIcon = ActionIcon

export default Icon
